import { API } from "config";
import request from "utilities/request";

const fileApiBaseUrl = API.fileApi.url;

export async function deleteFile(
  fileId: string,
  getAccessToken: () => Promise<string>
) {
  const accessToken = await getAccessToken();
  const url = `${fileApiBaseUrl}/api/v1/files/${fileId}`;

  const method = "DELETE";

  const options = { method };

  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  const optionsWithHeaders = { ...options, headers };
  const response = await request(url, optionsWithHeaders);

  let responseJson = {
    message: "File deleted successfully",
    fileId: fileId,
  };

  if (response.text.length > 0) {
    responseJson = await response.json();
  }
  return responseJson;
}
